import { useEffect, useRef, useState } from 'react'
import './Admin.css';
import StudentTableDisplay from './StudentTableDisplay';
export const GenerateAndUploadLogins = () => {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);
    const [refreshToggle, setRefreshToggle] = useState(false);

    function generatePassword(length = 6) {
        const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
        let password = "";
        for (let i = 0; i < length; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
    }
    const storageAccount = `https://egradstorage.table.core.windows.net/`;
    const tableName = `studentInterviewData`
    const sasToken = `sp=raud&st=2025-08-04T06:23:17Z&se=2026-08-06T14:38:00Z&spr=https&sv=2024-11-04&sig=aVectPGpxquw%2FjqSIzQB2Bk57AP4jwULmjqbLBeZEZE%3D&tn=studentInterviewData`;
    function handleFileUpload(event) {
        const file = event.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e) => {
            const text = e.target.result;
            const lines = text.trim().split('\n');
            console.log(lines, "these r lines");
            const rawHeaders = lines[0].split('\t');
            // const headers = lines[0].split('\t');
            // const headers = rawHeaders.map(h => h.trim().toLowerCase());
            const headers = rawHeaders.map(h => h.trim().toLowerCase().replace(/\s+/g, ''));
            const parsedStudents = lines.slice(1).map((line, index) => {
                const values = line.split('\t');
                const student = {};
                headers.forEach((header, i) => {
                    student[header.trim()] = values[i]?.trim();
                });
                // const { StudentNo, EmailId, ...rest } = student;
                const studentNo = student['studentno'];
            const emailId = student['emailid'];
            const studentName = student['studentname'];
                return {
                    PartitionKey: studentNo,
                    RowKey: `${emailId}`,
                    StudentName: studentName,
                    EmailId:emailId,
                    Password: generatePassword(),
                    TestCount: 0
                };
            });

            setStudents(parsedStudents);
        };

        reader.readAsText(file);
    }
    useEffect(() => {
        console.log("students data", students)
    }, [students])
    async function handleUpload() {
        let successCount = 0;
        let duplicateCount = 0;
        let failedRows = [];
        setLoading(true);
        try {
            for (const student of students) {
                const url = `${storageAccount}${tableName}?${sasToken}`;
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json;odata=nometadata',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(student),
                });
                if (response.status === 409) {
                    // Duplicate row
                    duplicateCount++;
                    console.warn(`Duplicate entry skipped: ${student.RowKey}`);
                    continue;
                }
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('Upload error:', student, errorText);
                    failedRows.push(student);
                    continue;
                }

                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('Failed to upload:', student, errorText);
                    failedRows.push(student);
                    continue;
                    // throw new Error(`Upload failed for RowKey ${student.RowKey}`);
                }
                successCount++;
            }
            let message = `✅ ${successCount} student(s) uploaded successfully.`;
            if (duplicateCount > 0) {
                message += ` ⚠️ ${duplicateCount} duplicate row(s) skipped.`;
            }
            if (failedRows.length > 0) {
                message += ` ❌ ${failedRows.length} row(s) failed. Check console.`;
            }

            alert(message);
            setRefreshToggle(prev => !prev);
            // alert('✅ All students uploaded successfully!');
            setStudents([]);
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }

        } catch (error) {
            console.error('❌ Upload failed:', error);
            alert('Upload failed. See console for more info.');
        }

        setLoading(false);
    }

    return (
        <div>
            <div className="upload-container">
                <h2>📤 Generate and Upload Logins</h2>

                <div className="form-group">
                    <label  className='tsvUpload' >Upload
                        <span> TSV File:</span></label>
                    <input
                        id="tsvUpload"
                        type="file"
                        accept=".tsv"
                        onChange={handleFileUpload}
                        disabled={loading}
                        ref={fileInputRef}
                    />
                </div>

                <div className="form-group">
                    <button
                        onClick={handleUpload}
                        disabled={loading || students.length === 0}
                    >
                        {loading ? 'Uploading...' : 'Upload to Azure'}
                    </button>
                </div>

                <p className="status">
                    {students.length > 0
                        ? `${students.length} students ready to upload.`
                        : 'No students loaded yet.'}
                </p>
            </div>
            <StudentTableDisplay sasToken={sasToken} tableName={tableName} storageAccount={storageAccount} refresh={refreshToggle} />

        </div>
    );

}
